import React from 'react';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DialogWithEnterAction from '../components/DialogWithEnterAction';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import { help } from '../Constants/help';
import { makeStyles } from '@material-ui/core/styles';

const style = {
  marginRight: 1,
  cursor: 'pointer',
  size: 1
};

const useStyles = makeStyles((theme) => ({
  infoicon: {
    color: theme.palette.text.primary,
    opacity: 0.7
  },
  infoButton: {
    minWidth: 44,
    minHeight: 44,
    marginLeft: 4
  }
}));

export default function Desc({ id, show, cont_type, ...other }) {
  const help = GetHelp(id, show, cont_type);
  return (
    <span>
      <DisplayName id={id} show={show} brief={help.brief} />
      <InfoButton content={help.content} table={help.table} img={help.img} brief={help.brief} />
    </span>
  );
}

export function GetHelp(id, show, cont_type) {
  const language = (i18next.language !== 'keys' ? i18next.language ?? 'en' : 'de').toLowerCase().split(/[-_]/)[0];
  const use_help = cont_type in help && id in help[cont_type] ? help[cont_type] : help['default'];
  const cur_help = id in use_help ? use_help[id] : show in use_help ? use_help[show] : undefined;
  const localized = cur_help?.[language] ?? cur_help?.en;
  return {
    brief: localized?.brief ?? '',
    content: localized?.full ?? '',
    table: localized?.table,
    img: localized?.image ?? ''
  };
}

export function DisplayName({ id, show, brief }) {
  let { t } = useTranslation();

  return t(show !== undefined ? show : id);
}

export function InfoButton({ content = '', table, img = '', brief = 'Info', ariaLabel }) {
  const [open, setOpen] = React.useState(false);
  const openDialog = (event) => {
    event.stopPropagation();
    setOpen(true);
  };
  const closeDialog = () => {
    setOpen(false);
  };
  const classes = useStyles();

  return (
    <span title={brief}>
      {(content !== '' || table !== undefined) && (
        <IconButton
          className={classes.infoButton}
          size="small"
          onClick={openDialog}
          aria-label={ariaLabel || brief || 'Info'}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              openDialog(event);
            }
          }}
        >
          <InfoOutlinedIcon className={classes.infoicon} style={style} fontSize="small" />
        </IconButton>
      )}
      <InfoDialog open={open} handleClose={closeDialog} content={content} table={table} img={img} />
    </span>
  );
}

function InfoDialog({ content, table, open, img, handleClose }) {
  let { t } = useTranslation();
  return (
    <DialogWithEnterAction
      open={open}
      onClose={handleClose}
      onEnterAction={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Info</DialogTitle>
      <DialogContent style={{ whiteSpace: 'pre-line' }}>
        {content}
        {table !== undefined && (
          <Table size="small" style={{ marginTop: content !== '' ? 16 : 0 }}>
            <TableHead>
              <TableRow>
                {table.headers.map((header) => (
                  <TableCell key={header}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {table.rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <TableCell key={cellIndex}>{cell}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
        {table?.footer !== undefined && <div style={{ marginTop: 16 }}>{table.footer}</div>}
      </DialogContent>
      {img !== '' && <img src={img} alt={img} />}
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('close')}
        </Button>
      </DialogActions>
    </DialogWithEnterAction>
  );
}
